import { getSessionData } from "./api/prism-api";
import { PrismSession, PrismSessionOptions } from "./PrismSession";

type CreatePrismSessionOptions = {
  sessionUrl: string;
  callbacks: PrismSessionOptions["callbacks"];
};

export type { PrismSession } from "./PrismSession";
export * from "./public-types";

export async function createPrismSession(
  options: CreatePrismSessionOptions
): Promise<PrismSession> {
  const sessionData = await getSessionData(options.sessionUrl);

  const session = new PrismSession({
    sessionData,
    callbacks: options.callbacks,
  });

  return session;
}
